import React from 'react';

interface FormFieldProps {
  label: string;
  type?: string;
  value: string;
  placeholder: string;
  required?: boolean;
  onChange: (value: string) => void;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  type = 'text',
  value,
  placeholder,
  required = false,
  onChange,
}) => (
  <div className="form-group">
    <label>{label}</label>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      required={required}
    />
  </div>
);
